module.exports = __webpack_public_path__ + "img/file-03.f4578357.svg";